<template>
  <v-container fluid>
    <v-row dense>
      <v-col
        id="collapse-point"
        class="scents"
        v-for="(card, index) in cards"
        v-bind:key="index"
        sm="12"
        md="6"
        cols="auto"
      >
        <v-hover v-slot:default="{ hover }">
          <v-card style="overflow: auto" :elevation="hover ? 12 : 2">
            <v-img
              :src="require('../assets/joao-silas-water-min.jpg')"
              class="white--text align-center"
              gradient="to bottom, rgba(0,0,0,.0), rgba(255,255,255,.2)"
              max-height="150px"
            >
              <v-card-title>{{ card.title }} Oil</v-card-title>
              <v-card-subtitle v-text="card.text"></v-card-subtitle>
            </v-img>
            <!-- <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>

              <v-btn icon>
                <v-icon>mdi-bookmark</v-icon>
              </v-btn>

              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions> -->
          </v-card>
        </v-hover>
      </v-col>
      <v-col v-if="inprogress" cols="12">
        <v-row justify="center">
          <v-hover v-slot:default="{ hover }">
            <v-card :elevation="hover ? 12 : 2">
              <v-card-title>**STILL IN PROGRESS**</v-card-title>
            </v-card>
          </v-hover>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    inprogress: false,
    cards: [
      {
        title: "Acai Berry & Satin Fragrance",
        text: ""
      },
      {
        title: "Amp Essential Blend",
        text: "Sanctum7 Original Made with: Lemon, Camphor, Peppermint, Sweet Orange, Bulgarian Lavender, and Cinnamon Leaf Oils. A spicy scent meant to wake you up."
      },
      {
        title: "Anise (Illicium Verum)",
        text: ""
      },
      {
        title: "Bergamot (Citrus bergamia)",
        text: ""
      },
      {
        title: "Black Amber & Lavendar Fragrance",
        text: ""
      },
      {
        title: "Bulgarian Lavender (Lavendula angustifolia)",
        text: ""
      },
      {
        title: "Cajeput	(Melaleuca Cajeputi)",
        text: ""
      },
      {
        title: "Camphor	(Cinnamomum Camphora)",
        text: ""
      },
      {
        title: "Cedarwood (Juniperus Mexicana)",
        text: ""
      },
      {
        title: "Cinnamon Leaf (Cinnamomum zeylanicum)",
        text: ""
      },
      {
        title: "Clove Bud (Syzgium aromaticum L.)",
        text: ""
      },
      {
        title: "Cucumber Fragrance",
        text: ""
      },
      {
        title: "Devotion Essential & Fragrance Blend",
        text: "Sanctum7 Original Made with: Peppermint, Vetiver, Cedarwood, Sweet Orange, German Blue Chamomile, and Fragrance Oils. Smokey and sweet."
      },
      {
        title: "Eucalyptus Blue Mallee (Eucalyptus Polybractea)",
        text: ""
      },
      {
        title: "Fir Needle (Abies Sibirica)",
        text: ""
      },
      {
        title: "Frankincense Essential & Fragrance",
        text: ""
      },
      {
        title: "German Blue Chamomile (Chamomilla Recutita)",
        text: ""
      },
      {
        title: "Green Tea & Cucumber Fragrance	",
        text: ""
      },
      {
        title: "Honey Almond Essential & Fragrance",
        text: ""
      },
      {
        title: "Lemon (Citrus Medica limonum)",
        text: ""
      },
      {
        title: "Origanum (Origanum Vulgare L.)",
        text: ""
      },
      {
        title: "Oud & Incense Fragrance",
        text: ""
      },
      {
        title: "Palmarosa (Cymbopogon Martini)",
        text: ""
      },
      {
        title: "Patchouli (Pogostemon Cablin)",
        text: ""
      },
      {
        title: "Peppermint (Mentha Piperia)",
        text: ""
      },
      {
        title: "Phantom Fragrance",
        text: "Bergamot and sandalwood with rich musk. Alluring, cologne-like scent."
      },
      {
        title: "Pistachio Macaron Fragrance",
        text: ""
      },
      {
        title: "Rainfall Fragrance",
        text: "Marine and green notes contrasted with cedarwood and musk."
      },
      {
        title: "Sweet Orange (Citrus sinensis)",
        text: ""
      },
      {
        title: "Vetiver	(Vetiveria Zizanoides)",
        text: "An strong earthy, leathery, and smoky scent. A premium essential oil add $1."
      },
      {
        title: "White Spruce (Picea alba)",
        text: "A premium essential oil add $1."
      },
      {
        title: "Ylang Ylang #1 (Cananga Odrata)",
        text: "A premium essential oil add $1."
      }
    ]
  })
};
</script>
